var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 38,
    viewBox: "0 0 47 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 27.001L24 19.001L16 27.001",
    stroke: "#727272",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 19.001V37.001",
    stroke: "#727272",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.78 31.7809C42.7307 30.7175 44.2716 29.0347 45.1597 26.9982C46.0478 24.9617 46.2324 22.6874 45.6844 20.5343C45.1364 18.3812 43.887 16.472 42.1333 15.1078C40.3797 13.7437 38.2217 13.0024 36 13.0009H33.48C32.8746 10.6594 31.7463 8.48561 30.1799 6.64293C28.6134 4.80025 26.6497 3.33665 24.4362 2.36216C22.2227 1.38767 19.8171 0.927662 17.4002 1.01671C14.9833 1.10576 12.6181 1.74154 10.4823 2.87628C8.34655 4.01101 6.4958 5.61515 5.06923 7.56811C3.64265 9.52107 2.67736 11.772 2.24594 14.1517C1.81452 16.5315 1.92819 18.978 2.57841 21.3075C3.22862 23.6369 4.39847 25.7887 5.99998 27.6009",
    stroke: "#727272",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 27.001L24 19.001L16 27.001",
    stroke: "#727272",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloudUpload.a0e190d0fa6ead08c220e87c7db03bbb.svg";
export { ForwardRef as ReactComponent };